import { useEffect, useState } from "react";
import api from "../api";
import ActivityFeed from "../components/ActivityFeed";

export default function ActivityHistory({ goHome, onJump }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let mounted = true;
    api.get(`/activity?limit=200`).then(({ data }) => {
      if (!mounted) return;
      setItems(data.items || []);
      setTotal(data.total || 0);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="view" data-testid="activity-history-view">
      <div className="crumb">
        <a onClick={goHome} data-testid="back-to-home">← Home</a>
        {" / "}
        Full activity history
      </div>

      <div className="sec-head" style={{ marginTop: 16 }}>Full activity history</div>
      <div className="sec-desc">
        {total === 0 ? "No activity recorded yet." : `Last ${items.length} events across the project.`}
      </div>

      <div className="actf-history-wrap">
        <ActivityFeed
          embedded
          limit={items.length || 1}
          onJump={onJump}
          data-testid="activity-history-feed"
        />
      </div>
    </div>
  );
}
